const { isValidURL } = require("./utils")
const { withAssetPrefix } = require("gatsby")

exports.Md5Script = options => {
  try {
    if (!!options) {
      options.url = withAssetPrefix("/scripts/vendors/md5.min.js")
      if (options.url) {
        return {
          src: options.url,
          beforeLoad: !!options.beforeLoad,
          defer: !!options.defer,
          async: !!options.async,
          onDCL: !!options.onDCL,
        }
      } else {
        return
      }
    } else {
      console.log(`Please verify the md5 url: ${options.url}`)
    }
  } catch (e) {
    console.log(`There is an error. md5 cannot be loaded.`)
  }
}
